export default __webpack_public_path__ + "static/Design-Development-dab1583105725bfa73ff1f5ac99cc22f.webp";